// extracted by mini-css-extract-plugin
export default {"description":"dUtw847q2ZUweWBZARqR"};